import axios from "axios";
import { API } from "../auth";

const KEY = "insurehub_endorsement_queue";

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};
const write = (items) => {
  try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent("endorsement-queue-changed", { detail: { count: items.length } }));
};

export const getQueue = () => read();
export const queueCount = () => read().length;

export const enqueueEndorsement = (payload, memberName) => {
  const items = read();
  items.push({
    id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    payload,
    member_name: memberName || payload.member_name || "Endorsement",
    queued_at: new Date().toISOString(),
    failed: false,
  });
  write(items);
};

export const clearQueue = () => write([]);

let flushing = false;

// Attempt to submit queued endorsements. includeFailed=true retries items that
// previously got a server rejection (used for manual retry via the badge).
export const flushQueue = async ({ includeFailed = false } = {}) => {
  if (flushing) return { ok: 0, failed: 0, skipped: 0 };
  if (!navigator.onLine) return { ok: 0, failed: 0, skipped: 0 };
  const token = localStorage.getItem("token");
  if (!token) return { ok: 0, failed: 0, skipped: 0 };

  flushing = true;
  let ok = 0, failed = 0;
  try {
    let items = read();
    const remaining = [];
    for (const item of items) {
      if (item.failed && !includeFailed) { remaining.push(item); continue; }
      try {
        await axios.post(`${API}/endorsements`, item.payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        ok += 1;
      } catch (err) {
        if (err.response) {
          // Server rejected (e.g. validation) — keep for review, mark failed.
          failed += 1;
          remaining.push({ ...item, failed: true, error: err.response?.data?.detail || "Rejected by server" });
        } else {
          // Network dropped mid-flush — keep as-is and stop trying for now.
          remaining.push(item);
        }
      }
    }
    write(remaining);
  } finally {
    flushing = false;
  }
  return { ok, failed };
};
